/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function BatchUpdateImportJobRowsRowFromJSON(json) {
    return BatchUpdateImportJobRowsRowFromJSONTyped(json, false);
}
export function BatchUpdateImportJobRowsRowFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        data: json['data'],
    };
}
export function BatchUpdateImportJobRowsRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        data: value.data,
    };
}
